import React, { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import Layout from "../components/Layout";
import Exchange from "../pages/exchange";
import Markets from "../pages/markets";
import Profile from "./profile";
import Wallet from "./wallet";
import Settings from "./settings";
import Login from "./login";
import Reset from "./reset";
import OtpVerify from "./otp-verify";
import OtpNumber from "./otp-number";
import Lock from "./lock";
import TermsAndConditions from "./terms-and-conditions";
import NewsDetails from "./news-details";
import Signup from "./signup";
import Notfound from "./notfound";
import PSXDownloads from "./psx-downloads";
import RsikDiscloure from "./riskDiscloure";
import SecpInvestorGuide from "./secpInvestorGuide";
import PsxRuleBook from "./psxRuleBook";
import DisputeAndArbitation from "./disputeAndArbitation";
import CommonTerms from "./commonTerms";
import TermsAndCondition from "./termsAndCondition";
import Policies from "./policies";
import CompanyProfile from "./company-profile";
import BoardOfDirectors from "./board-of-directors";
import CEOMessage from "./message-of-ceo";
import RegulatoryInfoEnhanced from "./reg-info";
import LegalAssociates from "./legal-associated";
import ContactUsEnhanced from "./contact-us";
import VisionMission from "./vision-misson";
import FinancialInfo from "./financial-info";
import OSPLLanding from "./about-online-trading";
import TradingPlatform from "./about-v-trader";
import DownloadTradingApps from "./download-trading-apps";
import DownloadAccOpening from "./download-account-opening-form";
import FAQSComponent from "./faq-component";
import OurServices from "./product-and-services";
import FundYourAccount from "./fund-your-account";
import BankDetails from "./bank-details";
import CommissionStructure from "./commision-structure";
import InvestorComplaints from "./investor-complaints-queries";
import ImportantLinks from "./important-links";
import TradingApps from "./software-download";
import AccountOpenDetails from "./account-open-detail";
import OfficeDetails from "./others-mandatory-information";
import NewHome from "./new-home";
import AccountForm from "./new-account";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import DemoLayout from "../components/DemoLayout";
import Home from "./demo-home";
import ComingSoon from "./coming-soon";
import PSXDashboard from "./trading-view";
import TradingViewChart from "../components/TradingViewChart";
import Technical from "./technicalAnalysis";
import { DummyTrading } from "./dummy-accounts/trading";
import { DummyProfile } from "./dummy-accounts/profile";
import DetailsPage from "./dummy-accounts/detail";
import { WatchList } from "./dummy-accounts/watchlist";
import { TradingDetails } from "./dummy-accounts/trading-details";
import { Logs } from "./dummy-accounts/logs";
import { useAuth } from "../hooks/auth";
// import BinanceCandlestickChart from "../components/ReactApexCahrt";
// import Users from "./user";

export default function Index() {
  let { authenticated } = useAuth();
  const { pathname } = useLocation();
  const history = useHistory();
    console.log(authenticated, "authentication");

  useEffect(() => {

    const protectedRoutes = [
      "/demo-home",
      "/demo-account",
      "/demo-details",
      "/trading-details",
      "/demo-watchlist",
      "/logs",
    ];
    const publicRoutes = [
      "/",
      "/home",
      "/markets",
      "/contact-us",
      "/about-online-trading",
      "/company-profile",
      "/vision-mission",
      "/financial-information",
      "/product-and-services",
      "/fund-your-account",
      "/bank-details",
      "/commision-structure",
      "/software-download",
      "/create-account",
      "/chart-view",
      "/coming-soon",
      "/technical-analysis",
    ];

    const matches = (routes) =>
      routes.some((r) => pathname === r || pathname.startsWith(r + "/"));

    const onProtected = matches(protectedRoutes);
    const onPublic = matches(publicRoutes);

    // Don't redirect until authenticated is resolved
    if (authenticated === null) return;

    // Unauthenticated user on a protected route
    if (authenticated === false && onProtected) {
      history.replace("/");
    }

    // Authenticated user on a public route
    if (authenticated === true && onPublic) {
      history.replace("/demo-home");
    }
  }, [authenticated, pathname]);

  return (
    <>
      {authenticated ? (
        <DemoLayout>
          <Switch>
            <Route exact path="/demo-home">
              <DummyTrading />
            </Route>
            <Route path="/demo-account">
              <DummyProfile />
            </Route>
            <Route path="/demo-details">
              <DetailsPage />
            </Route>
            <Route path="/trading-details/:id">
              <TradingDetails />
            </Route>
            <Route path="/demo-watchlist">
              <WatchList />
            </Route>
            <Route path="/create-account">
              <AccountForm />
            </Route>
            <Route path="/logs">
              <Logs />
            </Route>
          </Switch>
        </DemoLayout>
      ) : (
        <Layout>
          <Switch>
            <Route exact path="/home">
              <Exchange />
            </Route>
            <Route exact path="/">
              <NewHome />
            </Route>
            <Route path="/markets">
              <Markets />
            </Route>
            <Route path="/trading-dashboard">
              <PSXDashboard />
            </Route>
            <Route path="/profile">
              <Profile />
            </Route>
            <Route path="/wallet">
              <Wallet />
            </Route>
            <Route path="/settings">
              <Settings />
            </Route>
            {/* <Route path="/login">
              <Login />
            </Route>
            <Route path="/signup">
              <Signup />
            </Route> */}
            <Route path="/reset">
              <Reset />
            </Route>
            {/* <Route path="/otp-verify">
              <OtpVerify />
            </Route>
            <Route path="/otp-number">
              <OtpNumber />
            </Route> */}
            <Route path="/lock">
              <Lock />
            </Route>
            <Route path="/terms-and-conditions">
              <TermsAndConditions />
            </Route>
            <Route path="/news-details">
              <NewsDetails />
            </Route>
            <Route path="/notfound">
              <Notfound />
            </Route>
            <Route path="/psx-investor-guide">
              <PSXDownloads />
            </Route>
            <Route path="/risk-disclosure">
              <RsikDiscloure />
            </Route>

            <Route path="/secp-investor-guide">
              <SecpInvestorGuide />
            </Route>
            <Route path="/psx-rule-book">
              <PsxRuleBook />
            </Route>

            <Route path="/dispute-resolution-arbitration">
              <DisputeAndArbitation />
            </Route>

            <Route path="/common-terms-of-share-market">
              <CommonTerms />
            </Route>
            <Route path="/terms-conditions-of-online-trading">
              <TermsAndCondition />
            </Route>
            <Route path="/policies-procedures">
              <Policies />
            </Route>
            <Route path="/company-profile">
              <CompanyProfile />
            </Route>

            <Route path="/board-of-directors">
              <BoardOfDirectors />
            </Route>
            <Route path="/message-of-ceo">
              <CEOMessage />
            </Route>
            <Route path="/regulatory-info">
              <RegulatoryInfoEnhanced />
            </Route>

            <Route path="/legals-associated-companies">
              <LegalAssociates />
            </Route>
            <Route path="/contact-us">
              <ContactUsEnhanced />
            </Route>
            <Route path="/vision-mission">
              <VisionMission />
            </Route>
            <Route path="/financial-information">
              <FinancialInfo />
            </Route>
            <Route path="/about-online-trading">
              <OSPLLanding />
            </Route>
            <Route path="/about-vtrade-its-feature">
              <TradingPlatform />
            </Route>
            <Route path="/download-trading-apps">
              <DownloadTradingApps />
            </Route>
            <Route path="/download-account-opening-form">
              <DownloadAccOpening />
            </Route>
            <Route path="/faq">
              <FAQSComponent />
            </Route>
            <Route path="/product-and-services">
              <OurServices />
            </Route>
            <Route path="/fund-your-account">
              <FundYourAccount />
            </Route>
            <Route path="/bank-details">
              <BankDetails />
            </Route>
            <Route path="/commision-structure">
              <CommissionStructure />
            </Route>
            <Route path="/investor-complaints-queries">
              <InvestorComplaints />
            </Route>
            <Route path="/important-links">
              <ImportantLinks />
            </Route>
            <Route path="/software-download">
              <TradingApps />
            </Route>
            <Route path="/account-open-detail">
              <AccountOpenDetails />
            </Route>
            <Route path="/others-mandatory-information">
              <OfficeDetails />
            </Route>
            <Route path="/create-account">
              <AccountForm />
            </Route>
            <Route path="/chart-view">
              <TradingViewChart />
            </Route>
            <Route path="/coming-soon">
              <ComingSoon />
            </Route>
            <Route path="/technical-analysis">
              <Technical />
            </Route>

            {/* <Route path="/users">
            <Users />
          </Route> */}
          </Switch>
        </Layout>
      )}
    </>
  );
}
